__webpack_require__.p = "/react-grid-live-data/";